import React from 'react';
import { Header, Table } from 'semantic-ui-react';

import { escribirMonto } from '../../utilidades';

interface TablaTotalPagosPorAreaProps {
    totalPagosCuotasYCobrosCalculadosDelDia: number;
    totalOtrosPagos: number;
    totalPagos: number;
}

const TablaTotalPagosPorArea: React.FunctionComponent<TablaTotalPagosPorAreaProps> = props => {
    const { totalPagosCuotasYCobrosCalculadosDelDia, totalOtrosPagos, totalPagos } = props;
    return (
        <div>
            <Header as='h4'>Total pagos del día</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={12}>Tipo</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Total</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Cuotas, gastos notariales y abonos iniciales</Table.Cell>
                        <Table.Cell>
                            {escribirMonto(totalPagosCuotasYCobrosCalculadosDelDia)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Otros pagos</Table.Cell>
                        <Table.Cell>{escribirMonto(totalOtrosPagos)}</Table.Cell>
                    </Table.Row>
                    <Table.Row warning>
                        <Table.Cell>Total</Table.Cell>
                        <Table.Cell>{escribirMonto(totalPagos)}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
};

export default TablaTotalPagosPorArea;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaTotalPagosDelDia.tsx